const vh = px => {
  const screenH = window.screen.height;
  return (px / 5400) * screenH;
};

export { vh };
